<template>
  <div :class="[`sidebar`, visible ? `sidebar--visible` : ``]">
    <share-button expanded :link="getLink()" :download="pdfReport" />
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex'
import pdfReport from '@/assets/MO_Report.pdf'

import ShareButton from './ShareButton'

export default {
  name: `ui-sidebar`,

  // Components
  components: {
    ShareButton
  },
  // Data
  data () {
    return {
      pdfReport
    }
  },

  // Computed
  computed: {
    ...mapGetters(`sidebar`, [`visible`]),
    ...mapGetters(`page`, [`activeItem`])
  },

  // Methods
  methods: {
    ...mapActions(`sidebar`, [`toggleSidebar`]),
    getLink: () => `${window.location.protocol}//${window.location.host}`
  }
  // Watchers

  // Lifecycles
  // Filters
}
</script>
